<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import Selector2 from '@/components/formsExt/selector2/selector2.vue';
import type { Props } from './types';
import { folderDefault, genApiGetFolders, genFlat } from './utils';
import { apiSetSearchParamsFilter } from '@/components/formsExt/formsExt';
import { useWatch } from '@/core/utils/composables/useWatch';

const props = withDefaults(defineProps<Props>(), {
	addIcon: true,
});

const modelFolderId = defineModel<Props['folderId']>('folderId', { required: true });
const modelFolder = defineModel<NonNullable<Props['folder']>>('folder', { default: folderDefault });

const apiGet = props.client && !props.folders ? genApiGetFolders(props.client) : undefined;

const refSelector = ref<InstanceType<typeof Selector2> | null>(null);

// Настройка API
watch(() => props.projectId, () => {
	apiGet?.changeParams({
		project_id: props.projectId,
	});

	apiGet?.setOptions({
		checkFingerprint: 'TopGroupSelectorFolders:' + props.projectId,
	});

	refSelector.value?.resetCache();
}, { immediate: true });

/**
 * Плоский список папок
 */
const foldersFlat = computed(() => {
	return genFlat(props.folders ?? { root: [folderDefault] }, props.canSelectAll);
});

/**
 * Проверка входного значения `modelFolderId` и изменение `modelFolder`
 *
 * Определяем существует ли папка:
 * - Если существует: меняем папку на указанную
 * - Если не существует: устанавливаем Корневую папку
 *
 * При загрузке групп по API проверка выполняется в асинхронном режиме
 */
useWatch({
	modelFolder,
	modelFolderId,
}, async (changes) => {
	if (modelFolderId.value === modelFolder.value.id) {
		return;
	}

	// изменение только `modelFolder`
	if (changes.modelFolder && !changes.modelFolderId) {
		modelFolderId.value = modelFolder.value.id;

		return;
	}

	let folderSelected = foldersFlat.value.get(props.folderId);
	if (!folderSelected) folderSelected = folderDefault;

	modelFolder.value = folderSelected;
	modelFolderId.value = folderSelected.id;

	// /**
	//  * Для не api
	//  */
	// if (props.folders) {
	// 	modelFolder.value = folderSelected;
	// 	modelFolderId.value = folderSelected.id;
	// }
	//
	// /**
	//  * Для api проверка не делается
	//  */
	// if (!props.folders) {
	// 	modelFolder.value = folderSelected;
	// 	modelFolderId.value = folderSelected.id;
	// }
}, { immediate: true });
</script>

<template>
	<Selector2
		class="top-groupSelector_folder"
		v-model="modelFolder"
		:items="folders ? [...foldersFlat.values()] : undefined"
		search-type="inline"
		:icon="addIcon ? '' : undefined"
		:api="folders ? undefined : apiGet"
		:apiSetSearchParams="(...args) => apiSetSearchParamsFilter(...args, 'name')"
		:addChanger
		useCache
	/>
</template>
